"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const chart_js_1 = require("chart.js");
const chartjs_plugin_datalabels_1 = __importDefault(require("chartjs-plugin-datalabels"));
const COLOR = '214, 169, 90';
const DATAPOINT_COLOR = '#b48e4c';
const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    } : null;
};
let ChartComponent = class ChartComponent {
    constructor() {
        this.initialized = false;
        this.chartId = `canvas-${Math.random()}`;
        this.initChart = () => {
            switch (this.chartType) {
                case 'bar':
                    chart_js_1.Chart.register(chart_js_1.BarElement, chart_js_1.BarController);
                    break;
                case 'line':
                    console.log('register line');
                    chart_js_1.Chart.register(chart_js_1.LineController, chart_js_1.LineElement, chart_js_1.PointElement);
                    break;
                default: break;
            }
            this.chart = new chart_js_1.Chart(document.getElementById(this.chartId), {
                type: this.chartType,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    // animation: {
                    //   easing: 'easeInOutElastic',
                    // },
                    indexAxis: this.chartType === 'bar' ? 'y' : 'x',
                    plugins: {
                        legend: {
                            display: true,
                        },
                        datalabels: this.showLabels ? {
                            backgroundColor: DATAPOINT_COLOR,
                            borderRadius: 4,
                            color: 'white',
                            font: {
                                weight: 'bold',
                            },
                            formatter: (val, ctx) => (`${ctx.dataset.label} (${this.roundUpToOneDecimal(val)})`),
                            padding: 6,
                        } : undefined,
                    },
                },
                data: { labels: [], datasets: [] },
            });
            this.chartData.datasets.forEach((dataset) => {
                if (dataset.borderColor) {
                    const hex = hexToRgb(dataset.borderColor);
                    if (hex) {
                        const gradient = this.chart.ctx.createLinearGradient(0, 0, 0, 500);
                        gradient.addColorStop(0, `rgba(${hex.r}, ${hex.g}, ${hex.b}, 0.25)`);
                        gradient.addColorStop(0.5, `rgba(${hex.r}, ${hex.g}, ${hex.b}, 0.125)`);
                        gradient.addColorStop(1, `rgba(${hex.r}, ${hex.g}, ${hex.b}, 0)`);
                        dataset.fill = 'start';
                        dataset.backgroundColor = gradient;
                    }
                }
            });
            this.chart.data = this.chartData;
            this.chart.update();
            if (this.showLabels) {
                chart_js_1.Chart.register(chartjs_plugin_datalabels_1.default);
            }
        };
        this.roundUpToOneDecimal = (value) => {
            // eslint-disable-next-line no-restricted-properties
            const precision = Math.pow(10, 1);
            const roundedValue = Math.ceil(value * precision) / precision;
            return roundedValue.toFixed(1);
        };
        this.backgroundColor = (datasetIndex, datasetCount) => {
            if (this.colorMode === 'multi')
                return `rgba(${COLOR}, ${(1 / datasetCount) * (datasetIndex + 1)})`;
            return `rgba(${COLOR}, .8)`;
        };
        chart_js_1.Chart.register(chart_js_1.CategoryScale, chart_js_1.LinearScale, chart_js_1.RadialLinearScale, chart_js_1.Filler, chart_js_1.Tooltip, chart_js_1.Title, chart_js_1.Legend);
    }
    /** Initializes a HTML chart element only once and registers Chart.js to it */
    ngDoCheck() {
        if (this.initialized)
            return;
        const context = document.getElementById(this.chartId);
        if (!context)
            return;
        this.initialized = true;
        this.initChart();
    }
    ngOnChanges(changes) {
        if (!this.chart)
            return;
        if (changes.ghost && !changes.ghost.currentValue) {
            this.chart.update();
        }
        if (changes.chartData) {
            this.chartData.datasets.forEach((d, i) => {
                d.backgroundColor = this.backgroundColor(i, this.chartData.datasets.length);
                d.borderRadius = 15;
            });
            this.chart.destroy();
            this.initChart();
        }
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof chart_js_1.ChartType !== "undefined" && chart_js_1.ChartType) === "function" ? _a : Object)
], ChartComponent.prototype, "chartType", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_b = typeof chart_js_1.ChartData !== "undefined" && chart_js_1.ChartData) === "function" ? _b : Object)
], ChartComponent.prototype, "chartData", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], ChartComponent.prototype, "colorMode", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], ChartComponent.prototype, "showLabels", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], ChartComponent.prototype, "ghost", void 0);
ChartComponent = __decorate([
    (0, core_1.Component)({
        selector: 'chart',
        templateUrl: require('./chart.component.html'),
    }),
    __metadata("design:paramtypes", [])
], ChartComponent);
exports.default = ChartComponent;
